import React from 'react';
import { ButtonProps } from '../../types';

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  icon,
  href,
  className = '',
  ...props
}) => {
  const baseStyles = 'font-bold rounded-full transition-all duration-300 transform hover:scale-105 inline-flex items-center justify-center gap-2';
  
  const variantStyles = {
    primary: 'bg-green-600 text-white hover:bg-green-500 shadow-lg shadow-green-600/20',
    secondary: 'bg-gray-700 text-white hover:bg-gray-600',
    ghost: 'bg-transparent text-green-400 hover:text-green-300 border border-green-600'
  };
  
  const sizeStyles = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-3 px-8 text-base',
    lg: 'py-4 px-10 text-lg'
  };
  
  const widthStyle = fullWidth ? 'w-full' : '';
  
  const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${className}`.trim();
  
  if (href) {
    return (
      <a
        href={href}
        className={combinedClassName}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
        {icon}
      </a>
    );
  }
  
  return (
    <button
      className={combinedClassName}
      {...props}
    >
      {children}
      {icon}
    </button>
  );
};
